import React from 'react';
import type { MessageFlowDirection, StudentHistoryMessage } from '../../../types/studentHistory';
import MessageTimestamp from './MessageTimestamp';
import styles from './MessageBubble.module.css';

interface MessageBubbleProps {
  message: StudentHistoryMessage;
  messageFlow: MessageFlowDirection;
}

const MessageBubble: React.FC<MessageBubbleProps> = ({ message, messageFlow }) => {
  const isOutgoing = messageFlow === 'outgoing';

  return (
    <article className={`${styles.bubble} ${isOutgoing ? styles['bubble-outgoing'] : styles['bubble-incoming']}`}>
      <p className={styles.text}>{message.message}</p>
      <MessageTimestamp timestamp={message.message_at} isOutgoing={isOutgoing} />
    </article>
  );
};

export default MessageBubble;
